export default "__VITE_ASSET__DJJBRj8Q__"